export default "__VITE_ASSET__CLonqJ02__"